"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultSettings_1 = require("../defaultSettings");
/**
 * Get file size.
 */
exports.getFileSize = function (file) {
    return file.length || file.size;
};
/**
 * Check if FileData is multipart data.
 */
exports.isMultipart = function (fileSize, multipartMinFileSize) {
    if (multipartMinFileSize === void 0) { multipartMinFileSize = defaultSettings_1.default.multipartMinFileSize; }
    return fileSize >= multipartMinFileSize;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uploadcare/upload-client/lib/tools/isMultipart.js
// module id = 647
// module chunks = 70